module.exports = "<div class=gmc-panel-icon><img class=gmc-panel-icon__img src={{::$ctrl.icon}}><div class=gmc-panel-icon__header>{{::$ctrl.header}}</div></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-panel-icon/gmc-panel-icon.component.html
// module id = 869
// module chunks = 31